import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import {
    EnterValueInput,
    EnterValueResponse,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { ChangeCurrentClientDialogComponent } from '../../administration/client/change-current-client/change-current-client-dialog/change-current-client-dialog.component';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    ConditionSetting,
    ConditionTableColumn,
    NumberTableColumn,
    PdfTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { FileUploadService } from '../../dialogs/file-upload-dialog/file-upload.service';
import { Kundengutschrift } from './gutschrift';
import { GutschriftDetailsDialogComponent } from './gutschrift-details-dialog/gutschrift-details-dialog.component';

@Component({
    selector: 'kiene-gutschriften',
    templateUrl: './gutschriften.component.html',
    styleUrls: ['./gutschriften.component.css'],
})
export class GutschriftenComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();
    currentClient: Client;

    constructor(
        public dialog: MatDialog,
        private router: Router,
        private api: KieneTableService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private pdfService: PdfViewerDesktopService,
        private fileUploadService: FileUploadService,
        private route: ActivatedRoute,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {
        this.localStorageService.setCurrentClientVisible(true);
    }

    ngOnInit() {
        this.currentClient = this.localStorageService.getCurrentClient();

        this.localStorageService.watchCurrentClient().subscribe(client => {
            this.currentClient = client;
        });

        this.tableDescriptor.headline = 'Gutschriften';
        this.tableDescriptor.uniqueIdentifier = 'Gutschriften';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'kundengutschrift/';
        // this.tableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'kundengutschrift/read_kunden.php';
        this.tableDescriptor.route = '/finanzen/gutschriften/';
        this.tableDescriptor.nameOfIdField = 'kundengutschrift_id';
        this.tableDescriptor.searchPlaceholder = 'ID, Kunde oder Tierarzt suchen';
        this.tableDescriptor.columns.push(new TableColumn('kundengutschrift_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('kunde', 'Kunde'));
        this.tableDescriptor.columns.push(new TableColumn('zusatz', 'Zusatz'));
        this.tableDescriptor.columns.push(new TableColumn('tierarzt', 'Tierarzt'));
        this.tableDescriptor.columns.push(new TableColumn('rechnung_nr', 'Rechnung Nr.'));
        this.tableDescriptor.columns.push(new NumberTableColumn('gesamt_brutto', 'Betrag Brutto (Euro)', '1.2-2'));
        this.tableDescriptor.columns.push(new TableColumn('datum', 'Datum Gutschrift', 'date'));
        this.tableDescriptor.columns.push(new TableColumn('erstellt', 'Erstellt Am', 'datetime'));

        const conditionSettings = [
            new ConditionSetting([new Condition('primanota_id', Operator.EXISTIERT, null)], {
                icon: 'check',
                color: 'green',
                tooltip: 'Bereits zur FiBu exportiert',
            }),
        ];
        this.tableDescriptor.columns.push(
            new ConditionTableColumn('primanota_id', 'Primanota', conditionSettings, { sortFields: ['primanota_id'] }),
        );

        if (this.localStorageService.currentUserHasPermissions([2945])) {
            this.tableDescriptor.columns.push(new PdfTableColumn('pdf_id', 'PDF', this.showPdf.bind(this)));
        }

        this.tableDescriptor.toolbarButtons.push(
            new ToolbarButton(this.openProvisionDialog.bind(this), 'request_quote', 2949, 'Ergänzerprovisionen erzeugen'),
        );

        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsVoid = this.openEditDialog.bind(this);

        this.tableDescriptor.permissionView = 2941;
        this.tableDescriptor.permissionCreate = 2943;
        this.tableDescriptor.addVoid = this.createNewGutschriftDialog.bind(this);

        this.tableDescriptor.options.push(
            new TableOption(this.loadAndShowGutschriftPdf.bind(this), 'PDF neu erstellen', 'picture_as_pdf', 2945, {
                conditions: [new Condition('primanota_id', Operator.EXISTIERT_NICHT, undefined)],
            }),
        );
        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'Bearbeiten', 'edit', 2943));
        this.tableDescriptor.options.push(
            new TableOption(this.navigateToRechnung.bind(this), 'Rechnung anzeigen', 'receipt', 2971, {
                conditions: [new Condition('rechnung_id', Operator.EXISTIERT, '')],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openDeleteDialog.bind(this), 'Löschen', 'delete', 2944, {
                conditions: [
                    new Condition('primanota_id', Operator.EXISTIERT_NICHT, null),
                    new Condition('rechnung_id', Operator.EXISTIERT_NICHT, null),
                ],
            }),
        );

        this.tableDescriptor.initialSortColumn = 'erstellt';
        this.tableDescriptor.initialSortDirection = 'desc';

        this.fileUploadService.watchFileUploaded().subscribe(result => {
            if (result) {
                this.api.reload();
            }
        });
    }

    showPdf(gutschrift: Kundengutschrift) {
        const input = new PdfViewerDialogInput(
            'kundengutschrift/read_or_mail_pdf.php',
            new HttpParams().set('kundengutschrift_id', gutschrift?.kundengutschrift_id?.toString()),
            'Gutschrift ' + gutschrift?.kundengutschrift_id?.toString(),
            { email: { sende_mail: true, kunde_id: gutschrift?.kunde_id } },
        );
        // bei Gutschriften die Rechnungsemailadresse verwenden
        input.isInvoice = true;
        this.pdfService.openPdfViewer(input);
    }

    private navigateToRechnung(gutschrift: Kundengutschrift) {
        this.router.navigate(['../rechnungen', gutschrift.rechnung_id], { relativeTo: this.route }).then();
    }

    private loadAndShowGutschriftPdf(gutschrift: Kundengutschrift) {
        this.api
            .getOne(
                this.apiBaseUrl + 'kundengutschrift/create_pdf.php',
                'kundengutschrift_id',
                gutschrift?.kundengutschrift_id?.toString(),
            )
            .subscribe({
                next: () => {
                    this.api.reload();

                    const input = new PdfViewerDialogInput(
                        'kundengutschrift/read_or_mail_pdf.php',
                        new HttpParams().set('kundengutschrift_id', gutschrift?.kundengutschrift_id?.toString()),
                        'Gutschrift ' + gutschrift?.kundengutschrift_id?.toString(),
                        { email: { sende_mail: true, kunde_id: gutschrift?.kunde_id } },
                    );
                    // bei Gutschriften die Rechnungsemailadresse verwenden
                    input.isInvoice = true;
                    this.pdfService.openPdfViewer(input);
                },
                error: err => {
                    this.messageService.errorMessage('PDF konnte nicht erstellt werden!', err);
                },
            });
    }

    // openAddGutschriftDialog(g?: Gutschrift) {
    //   const dialogRef = this.dialog.open(AddGutschriftDialogComponent, {
    //     width: '500px',
    //     data: {
    //       gutschrift: g,
    //       apiUrl: 'gutschrift/update.php'
    //     }
    //   });

    //   dialogRef.afterClosed().subscribe(result => {
    //     this.api.reload();
    //   });

    // }

    openDeleteDialog(kg: Kundengutschrift) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: {
                title: 'Gutschrift wirklich löschen?',
                text: 'Gutschrift wirklich löschen?',
                textButton: 'löschen',
            },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.api.deleteEntity(this.apiBaseUrl + 'kundengutschrift/delete.php', kg).subscribe(
                    () => {
                        this.messageService.infoMessage('Die Gutschrift wurde erfolgreich gelöscht!');
                        this.api.reload();
                    },
                    error => {
                        this.messageService.errorMessage('Die Gutschrift konnte nicht gelöscht werden! ', error);
                    },
                );
            }
        });
    }

    createNewGutschriftDialog() {
        if (!this.currentClient) {
            const dialogRef = this.dialog.open(ChangeCurrentClientDialogComponent, { width: '50%' });

            dialogRef.afterClosed().subscribe(result => {
                if (result?.save) {
                    const selectedClient: Client = result.client;
                    const kgutschrift = new Kundengutschrift();
                    kgutschrift.kunde_id = selectedClient.kunde_id;
                    kgutschrift.kunde = selectedClient.bezeichnung_final;
                    const dialogRefDetails = this.dialog.open(GutschriftDetailsDialogComponent, {
                        width: '90%',
                        data: { kundengutschrift: kgutschrift },
                    });
                    dialogRefDetails.afterClosed().subscribe(saved => {
                        if (saved) {
                            this.api.reload();
                        }
                    });
                }
            });
        } else {
            const kgutschrift = new Kundengutschrift();
            kgutschrift.kunde_id = this.currentClient.kunde_id;
            kgutschrift.kunde = this.currentClient.bezeichnung_final;
            const dialogRef = this.dialog.open(GutschriftDetailsDialogComponent, {
                width: '90%',
                data: { kundengutschrift: kgutschrift },
            });
            dialogRef.afterClosed().subscribe(saved => {
                if (saved) {
                    this.api.reload();
                }
            });
        }
    }

    openEditDialog(gutschrift: Kundengutschrift) {
        const dialogRef = this.dialog.open(GutschriftDetailsDialogComponent, {
            width: '90%',
            data: { kundengutschrift: gutschrift },
        });
        dialogRef.afterClosed().subscribe(saved => {
            if (saved) {
                this.api.reload();
            }
        });
    }

    openProvisionDialog() {
        const enterValueInput = new EnterValueInput();
        enterValueInput.title = 'Gutschriften für Provisionen erzeugen';
        enterValueInput.text =
            'Es werden für alle Tierärzte Provisionsgutschriften erzeugt, die bis zum Ende des eingegebenen Zeitraums Ergänzerfuttermittel vertrieben haben.';
        enterValueInput.okButton = 'Provisionen erzeugen';
        enterValueInput.addInputValue('Ende des Zeitraums', 'date');

        const dialogRef = this.dialog.open(EnterValueDialogComponent, {
            width: '33%',
            minWidth: '300px',
            data: enterValueInput,
        });

        dialogRef.afterClosed().subscribe({
            next: (response: EnterValueResponse) => {
                console.log(response);
                if (response.result) {
                    const obj = { bis: response.getValue(0) };
                    this.api
                        .post(this.apiBaseUrl + 'kundengutschrift/generieren_provision.php', obj, undefined)
                        .subscribe({
                            next: () => {
                                this.messageService.infoMessage(
                                    'Die Provisionsgutschriften wurden erfolgreich erzeugt!',
                                );
                                this.api.reload();
                            },
                            error: err => {
                                this.messageService.errorMessage(
                                    'Die Provisionsgutschriften konnten nicht erzeugt werden!',
                                    err,
                                );
                                this.api.reload();
                            },
                        });
                }
            },
        });
    }
}
